import { createUseStyles } from "react-jss";
import { breakpoints } from "../../constants/breakpoints";
import { colors } from "../../constants/colors";
import { APP_PREFIX } from "../../constants/appConstants";

const general = createUseStyles((theme) => ({
  main: {
    fontFamily: theme.fontFamily,
    '-webkit-font-smoothing': 'antialiased',
  },
  formFields: {
    '& input:not([role="combobox"]):not([type="checkbox"]):not([type="radio"]):not([type="password"]):not([type="file"]):not([class^="tagItem"]):not([class^="errorTagItem"]):not([class^="addInput"]):not([name="aadvantage"]):not([name="membershipNumber"]):not([name="maxPricePerNight"]):not([name="maxTripFare"])':
      {
        border: `1px solid ${theme.field.borderColor}`,
        color: theme.field.textColor,
        backgroundColor: theme.field.backgroundColor,
        '&:focus': {
          borderColor: theme.field.borderColorFocus,
          backgroundColor: theme.field.backgroundColorFocus,
        },
        '&::placeholder': {
          color: theme.field.placeholderColor,
        },
        '&:disabled': {
          borderColor: theme.field.borderColorDisabled,
          backgroundColor: theme.field.backgroundColorDisabled,
          color: theme.field.textColorDisabled,
          '&::placeholder': {
            color: theme.field.placeholderColorDisabled,
          },
        },
        '&[class^="inputEmail"]': {
          border: 'none',
          backgroundColor: 'transparent !important',
          '&:focus': {
            borderColor: 'none',
            backgroundColor: 'transparent !important',
          },
        },
        '&[class^="input-error"]': {
          border: '1px solid ' + theme.field.borderColorError,
        },
        '&[name="searchTerm"]': {
          border: 'none',
        },
      },
    '& [class^="editDiv"]': {
      border: `1px solid ${theme.field.borderColor}`,
      '& > input': {
        border: 'none !important',
      },
    },
    '& [class^="editDiv"] > span > [class*="editButton"]': {
      borderLeft: `1px solid ${theme.field.borderColor} !important`,
    },
    '& [class^="editDiv"] > span': {
      '& [class*="disabled"]': {
        border: `1px solid ${theme.field.borderColor}`,
      },
    },
    '& [class^="emailAddressesContainer"]': {
      border: `1px solid ${theme.field.borderColor}`,
      '&:focus-within': {
        border: '1px solid ' + theme.field.borderColorFocus,
      },
    },
    '& [class*="errorBorder"]': {
      border: '1px solid' + theme.field.borderColorError,
    },
    '& [class*="invitePeopleModal"]': {
      '& [class*="input-group-text"]': {
        border: `1px solid ${theme.field.borderColor}`,
      },
    },
    '& [class^="inputContainerWithSvg"]': {
      '& input': {
        border: 'none !important',
      },
    },
    '& [class^="inputContainerMembership"]': {
      '& div': {
        border: `1px solid ${theme.field.borderColor}`,
      },
    },
    '& [class*="searchLang"]': {
      '& input': {
        border: "none !important",
      }
    },
  },
  modal: {
    '& .modal-content': {
      borderRadius: '12px',
      boxShadow:
        '0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)',
    },
    fontFamily: theme.fontFamily,
    '-webkit-font-smoothing': 'antialiased',
    '& .form-check-input:checked': {
      backgroundColor: theme.modal.backgroundColor,
      border: theme.modal.border,
      outline: theme.modal.outline,
    },
    '& .form-check-input:checked[type=radio]': {
      backgroundImage: 'none',
    },
    '& .form-check-input:focus': {
      boxShadow: theme.modal.boxShadow,
    },
  },
  pageWrapper: {
    // paddingLeft: "280px",
    padding: '32px 32px 0 312px',
    [`@media (max-width: ${breakpoints.md}px)`]: {
      padding: '32px 32px 0',
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: '16px 16px 0',
    },
  },
  '@font-face': [
    {
      fontFamily: 'Inter',
      src: `url(${APP_PREFIX}/fonts/Inter.woff2) format("woff2"), url(${APP_PREFIX}/fonts/Inter.woff) format("woff")`,
    },
    {
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '400',
      fontDisplay: 'fallback',
      src: `url(${APP_PREFIX}/fonts/Inter-Regular.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '500',
      fontDisplay: 'fallback',
      src: `url(${APP_PREFIX}/fonts/Inter-Medium.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '600',
      fontDisplay: 'fallback',
      src: `url(${APP_PREFIX}/fonts/Inter-SemiBold.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '700',
      fontDisplay: 'fallback',
      src: `url(${APP_PREFIX}/fonts/Inter-Bold.woff2) format("woff2")`,
    },
    //  Whitney font faces
    {
      fontFamily: 'Whitney',
      fontStyle: 'normal',
      fontWeight: 400, // Book
      src: `url(${APP_PREFIX}/fonts/Whitney-Book.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Whitney',
      fontStyle: 'italic',
      fontWeight: 400, // Book Italic
      src: `url(${APP_PREFIX}/fonts/Whitney-Book-Italic.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Whitney',
      fontStyle: 'normal',
      fontWeight: 500, // Medium
      src: `url(${APP_PREFIX}/fonts/Whitney-Medium.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Whitney',
      fontStyle: 'italic',
      fontWeight: 500, // Medium Italic
      src: `url(${APP_PREFIX}/fonts/Whitney-Medium-Italic.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Whitney',
      fontStyle: 'normal',
      fontWeight: 600, // SemiBold
      src: `url(${APP_PREFIX}/fonts/Whitney-Semibold.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Whitney',
      fontStyle: 'italic',
      fontWeight: 600, // SemiBold Italic
      src: `url(${APP_PREFIX}/fonts/Whitney-Semibold-Italic.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Whitney',
      fontStyle: 'normal',
      fontWeight: 700, // Bold
      src: `url(${APP_PREFIX}/fonts/Whitney-Bold.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Whitney',
      fontStyle: 'italic',
      fontWeight: 700, // Bold Italic
      src: `url(${APP_PREFIX}/fonts/Whitney-Bold-Italic.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Whitney',
      fontStyle: 'normal',
      fontWeight: 900, // Black
      src: `url(${APP_PREFIX}/fonts/Whitney-Black.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Whitney',
      fontStyle: 'italic',
      fontWeight: 900, // Black Italic
      src: `url(${APP_PREFIX}/fonts/Whitney-Black-Italic.woff2) format("woff2")`,
    },
    // Whitney Condensed fonts
    {
      fontFamily: 'Whitney Condensed',
      fontStyle: 'normal',
      fontWeight: 400, // Condensed Book
      src: `url(${APP_PREFIX}/fonts/Whitney-Condensed-Book.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Whitney Condensed',
      fontStyle: 'normal',
      fontWeight: 300, // Condensed Light
      src: `url(${APP_PREFIX}/fonts/Whitney-Condensed-Light.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Whitney Condensed',
      fontStyle: 'normal',
      fontWeight: 500, // Condensed Medium
      src: `url(${APP_PREFIX}/fonts/Whitney-Condensed-Medium.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Whitney Condensed',
      fontStyle: 'normal',
      fontWeight: 600, // Condensed SemiBold
      src: `url(${APP_PREFIX}/fonts/Whitney-Condensed-Semibold.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Whitney Condensed',
      fontStyle: 'normal',
      fontWeight: 700, // Condensed Bold
      src: `url(${APP_PREFIX}/fonts/Whitney-Condensed-Bold.woff2) format("woff2")`,
    },
    {
      fontFamily: 'Whitney Condensed',
      fontStyle: 'normal',
      fontWeight: 900, // Condensed Black
      src: `url(${APP_PREFIX}/fonts/Whitney-Condensed-Black.woff2) format("woff2")`,
    },
  ],
}));

export default general;
